import styled from 'styled-components';

export const Greenhouses = styled.div`
  background: white;
  min-height: 100%;
`
